import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { PATH } from '../../../../constants/path';

import { fetchAccountEbonOrdersIfNeeded } from '../../../../services/account/ebons/actions';

import { createOrder } from '../../../../utils/ebonOrderUtils';

import EbonOrderCard from './EbonOrderCard';
import HeadComponent from '../../../HeadComponent';
import { LoadingComponent } from '../../../loading/LoadingComponent';
import LocalizedBreadcrumbItem from '../../../breadcrumb/LocalizedBreadcrumbsItem';

const EbonsPage = ({ i18nPage, fetchAccountEbonOrdersIfNeeded, ebonOrders, fetching }) => {
    useEffect(() => {
        fetchAccountEbonOrdersIfNeeded();
    }, []);
    return (
        <main id="p-compte-bons-d-achat" style={{ marginTop: '32px' }}>
            <HeadComponent title={i18nPage.TITLE} description={i18nPage.DESCRIPTION} />
            <LocalizedBreadcrumbItem to={PATH.ACCOUNT_EBONS_PATH}>
                {i18nPage.BREADCRUMB}
            </LocalizedBreadcrumbItem>

            {fetching && <LoadingComponent />}
            {!fetching &&
                ebonOrders.length > 0 &&
                ebonOrders.map(
                    ({ items, id, date, mergedItems, billNumber, partnerId, vendorName }) => (
                        <EbonOrderCard
                            key={id}
                            billNumber={billNumber}
                            items={items}
                            mergedItems={mergedItems}
                            id={id}
                            vendor={vendorName}
                            partnerId={partnerId}
                            date={date}
                        />
                    )
                )}
            {!fetching && ebonOrders.length === 0 && (
                <div className="no-ebons">{i18nPage.NO_EBONS}</div>
            )}
        </main>
    );
};

EbonsPage.propTypes = {
    i18nPage: PropTypes.object.isRequired,
    ebonList: PropTypes.array
};

const mapStateToProps = state => {
    const ebonOrders = filterEbonOrders(state.account.myebons.ebonOrders);

    return {
        i18nPage: state.i18n.page.ACCOUNT.EBONS,
        ebonOrders: mapEbonOrders(ebonOrders, state.ebon.ebonPartners),
        fetching: state.account.myebons.fetching
    };
};

const filterEbonOrders = orders => {
    return orders.filter(order => order.ebonList.length > 0);
};

const mapEbonOrders = (orders, ebonPartners) => {
    return orders.map(o => createOrder({ ...o }, ebonPartners));
};

const mapDispatchToProps = {
    fetchAccountEbonOrdersIfNeeded
};

export default connect(mapStateToProps, mapDispatchToProps)(EbonsPage);



// WEBPACK FOOTER //
// ./src/components/pages/account/myebons/EbonsPage.js